import $ from 'jquery'
import CONSTS from '../constants'
import Component from './component'

export class TopNavigation extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    // classes extensions
    Object.assign(this.classes, {
      outerClickContainer: '.js-top-navigation-outer-click-container',
      menuLevel1: '.js-top-navigation-menu1',
      menuLevel2: '.js-top-navigation-menu2',
      menuItem: 'li',
      menuLevel1Item: '.js-top-navigation-menu1-item',
      showFormLink: '.js-top-navigation-show-form-link',
      rightItem: '.js-top-navigation-menu2-item-right',
      rightDefaultItem: '.js-top-navigation-menu2-item-right.h-default',
      notification: '.js-top-navigation-notification',
      form: 'form',
      input: 'input',
      inputSubmit: '.h-btn-submit',
      textarea: 'textarea',
      errorText: '.h-error-text',
      loginForm: '.js-top-navigation-login-form',
    })

    // classStates extensions
    Object.assign(this.classStates, {
      hasSubMenu: 'h-has-submenu',
      error: 'h-has-error',
    })

    this.ignoreHideMenu = false

    this.$outerClickContainer = this.$ctx.find(this.classes.outerClickContainer)

    this.$menuLevel1 = this.$ctx.find(this.classes.menuLevel1)
    this.$menuLevel2 = this.$ctx.find(this.classes.menuLevel2)

    // items
    this.$menuLevel1Items = this.$menuLevel1.find(`> ${this.classes.menuItem}`)
    this.$menuLevel2Items = this.$menuLevel2.find(`> ${this.classes.menuItem}`)

    this.$showFormLinks = this.$ctx.find(this.classes.showFormLink)

    this.$forms = this.$ctx.find(this.classes.form)
    this.$inputs = this.$ctx.find(this.classes.input)
    this.$loginForm = this.$ctx.find(this.classes.loginForm)

    this.bindMenuEvents()
    this.bindShowFormLinks()
    this.bindFormSubmits()

    this.listenToEvents()
  }

  bindMenuEvents() {
    this.$menuLevel1Items.find('> a').on('click', (event) => {
      const $me = $(event.currentTarget)
      const url = $me.attr('href')

      if (url === '' || url === '#') {
        event.preventDefault()
        event.stopPropagation()
      }
    })

    this.$menuLevel1Items.on('mouseover', (event) => {
      event.stopPropagation()

      if (this.ignoreHideMenu) {
        return
      }

      const $me = $(event.currentTarget)
      const $href = $me.find('> a')

      if ($href.hasClass(this.classStates.hasSubMenu)) {
        this.$outerClickContainer.addClass(this.classStates.active)

        this.$menuLevel1Items
          .removeClass(this.classStates.active)
          .removeClass(this.classStates.trail)

        $me.addClass(this.classStates.active)
      } else {
        // don't add trail
        this.hideNavigation()
        $me.addClass(this.classStates.active)

        // remove trail
        this.$menuLevel1Items.removeClass(this.classStates.trail)
      }
    })

    this.$menuLevel1Items.on('mouseleave', (event) => {
      const DELAY = 50
      const $me = $(event.currentTarget)

      if (this.ignoreHideMenu) {
        return
      }

      this.$outerClickContainer.removeClass(this.classStates.active)
      $me.removeClass(this.classStates.active)

      window.setTimeout(() => {
        this.makeDefaultRightVisibleAgain()
      }, DELAY)
    })

    this.$menuLevel2Items.on('mouseover', (event) => {
      event.stopPropagation()

      const $me = $(event.currentTarget)

      $me.addClass(this.classStates.active)
    })

    this.$menuLevel2Items.on('mouseout', (event) => {
      event.stopPropagation()

      const $me = $(event.currentTarget)

      $me.removeClass(this.classStates.active)
    })

    this.$outerClickContainer.on('click', (event) => {
      event.preventDefault()
      event.stopPropagation()

      this.hideNavigation()
      this.makeDefaultRightVisibleAgain()
    })
  }

  bindShowFormLinks() {
    this.$showFormLinks.on('click', (event) => {
      event.preventDefault()

      const $me = $(event.currentTarget)
      const form = $me.data('form')
      const $menuLevel2 = $me.parents(this.classes.menuLevel2)
      const $rightItems = $menuLevel2.find(this.classes.rightItem)
      const $formContainer = $menuLevel2.find(`.${form}`)

      if ($formContainer.length > 0) {
        $rightItems.removeClass(this.classStates.active)

        // make active and focus first input field
        $formContainer
          .addClass(this.classStates.active)
          .find('input:visible:first')
          .trigger('focus')
      }
    })
  }

  bindFormSubmits() {
    this.$forms.on('submit', (event) => {
      event.preventDefault()

      const $form = $(event.currentTarget)
      const $inputs = $form
        .find(this.classes.input)
        .not(this.classes.inputSubmit)
      const $textarea = $form.find(this.classes.textarea)
      const $errorTexts = $form.find(this.classes.errorText)
      const $notification = $form
        .closest(this.classes.menuLevel2)
        .find(this.classes.notification)

      $.ajax({
        type: 'POST',
        cache: false,
        data: $form.serialize(),
        dataType: 'json',
        url: $form.attr('action'),
        success: (data) => {
          if (data.status === 'error') {
            $inputs.removeClass(this.classStates.error)
            $textarea.removeClass(this.classStates.error)

            $errorTexts.empty().addClass(this.classStates.hidden)

            if (data.msg !== null && typeof data.msg === 'object') {
              for (const key in data.msg) {
                // eslint-disable-next-line no-prototype-builtins
                if (data.msg.hasOwnProperty(key)) {
                  const $input = $(`#${key}`, $form)
                  const $error = $(`#${key}_error`, $form)
                  const errorMsg = data.msg[key]

                  $input.addClass(this.classStates.error)

                  $error.html(errorMsg).removeClass(this.classStates.hidden)
                }
              }
            } else {
              // add to last input field
              $inputs.last().addClass(this.classStates.error)

              $errorTexts
                .last()
                .removeClass(this.classStates.hidden)
                .html(data.msg)
            }
            // works, form is sent
          } else if (data.status === 'success') {
            this.showNotification($notification, data.msg)

            // clean up form
            $inputs.removeClass(this.classStates.error).val('')

            $textarea.removeClass(this.classStates.error).val('')

            $errorTexts.empty().addClass(this.classStates.hidden)
            // works, we need to redirect
          } else if (data.status === 'success_redirect') {
            if (data.redirect.length > 0) {
              location.href = data.redirect
            }
          }
        },
        error: () => false,
      })
    })

    // enter current form on keypress enter
    this.$inputs.on('keypress', (event) => {
      const RADIX = 10
      const KEY_ENTER = 13

      if (window.parseInt(event.which, RADIX) === KEY_ENTER) {
        event.preventDefault()

        const $target = $(event.currentTarget)
        const $form = $target.closest(this.classes.form)

        $form.trigger('submit')
      }
    })

    this.$inputs.on('focusin', () => {
      this.ignoreHideMenu = true
    })

    this.$inputs.on('focusout', () => {
      this.ignoreHideMenu = false
    })
  }

  showNotification($notification, msg) {
    const DELAY = 2000

    $notification.find('p').html(msg)
    $notification.show()

    window.setTimeout(() => {
      $notification.hide()

      this.hideNavigation()
      this.makeDefaultRightVisibleAgain()
    }, DELAY)
  }

  hideNavigation() {
    this.$menuLevel1Items.removeClass(this.classStates.active)
    this.$outerClickContainer.removeClass(this.classStates.active)
  }

  makeDefaultRightVisibleAgain() {
    this.$ctx.find(this.classes.rightItem).removeClass(this.classStates.active)

    this.$ctx
      .find(this.classes.rightDefaultItem)
      .addClass(this.classStates.active)
  }

  listenToEvents() {
    this.ev.on(CONSTS.EVENTS.SHOW_LOGIN, () => {
      if (this.active && this.$loginForm.length > 0) {
        this.hideNavigation()

        this.$ctx
          .find(this.classes.rightItem)
          .removeClass(this.classStates.active)

        const $menuLevel1Item = this.$loginForm.closest(
          this.classes.menuLevel1Item
        )

        $menuLevel1Item.addClass(this.classStates.active)

        this.$outerClickContainer.addClass(this.classStates.active)

        // make active and focus first input field
        this.$loginForm
          .addClass(this.classStates.active)
          .find('input:visible:first')
          .trigger('focus')
      }
    })
  }

  onResize(winWidth) {
    if (winWidth > CONSTS.MOBILE_WIDTH) {
      this.active = true
    } else {
      this.active = false
    }
  }
}
